import React, { useEffect, useState } from 'react';
import "./Authorization.scss"
import logo from '../../images/logo.svg'
import Input from '../UI/Input/Input';

import { useFetching } from '../../hooks/useFetching';
import PostService from '../../API/PostService';

import Cookies from 'universal-cookie';

const Authorization = () => {
	const [ login, setLogin ] = useState('');
	const [ password, setPassword ] = useState('');
	const [ error, setError ] = useState('');

	const recieveLoginValue = (value) => {
		setLogin(value)
	}

	const recievePasswordValue = (value) => {
		setPassword(value)
	}

	const submit = () => {
		fetchAuthUser(login, password)
	}

	const [fetchAuthUser] = useFetching(async (login, password) => {
		const response = await PostService.authUser(login, password)
		if (response.data.success && response.data.result !== false) {
			if(response.data.result === true){
				const cookies = new Cookies(null, { path: '/', expires: new Date(Date.now() + 86400e3) });
				cookies.set('CRM-AUTH', 'Y');
				window.location.reload();
			} else {
				if(response.data.result?.TYPE === 'ERROR'){
					setError(response.data.result?.MESSAGE)
				}
			}
		}
	})

	return (
		<div className="auth">
			<div className="auth__container">
				<div className="auth__holder">
					<div className="auth__holder-logo">
						<img src={logo} alt="" />
					</div>
					<div className="auth__holder-form">
						<h2>Вход</h2>
						<div className="auth__holder-form-login">
							<Input label='Логин' inputHandler={recieveLoginValue}/>
						</div>
						<div className="auth__holder-form-password">
							<Input label='Пароль' inputHandler={recievePasswordValue} inputType='password' type='password'/>
						</div>
						{
							error !== '' &&
							<div className='auth__holder-form-error' dangerouslySetInnerHTML={{__html: error}}></div>
						}
						<div className="auth__holder-form-submit">
							<button className="g-button" onClick={submit}>Войти</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Authorization;
